import React, { useRef, useLayoutEffect } from "react";
import { Card, CardContent, Typography, Box, IconButton } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useState } from "react";
import "./NewJobpostingCard.css";

const NewJobpostingCard = ({
  data,
  onEventHandler,
  selectedCard,
  onCheckboxChange,
}) => {
  const [showMore, setShowMore] = useState(false);

  const skillcontainer = useRef(null);

  const skills = Array.isArray(data.formattedSkills)
    ? data.formattedSkills
    : [];

  const [visibleCount, setVisibleCount] = useState(skills?.length || 0);

  useLayoutEffect(() => {
    if (!skills.length) {
      setVisibleCount(0);
      setShowMore(false);
      return;
    }

    const container = skillcontainer.current;
    if (!container) return;

    const items = Array.from(container.children);
    if (!items.length) return;
    // Get row positions
    const tops = items.map((el) => el.offsetTop);
    const uniqueRows = [...new Set(tops)];
    // Case 1: all skills fit in one row
    if (uniqueRows.length === 1) {
      setVisibleCount(skills.length);
      setShowMore(false);
      return;
    }
    // Case 2: need 2 rows → calculate how many fit
    let count = skills.length;

    while (count > 0) {
      const visibleItems = items.slice(0, count + 1); // +1 for "+more"
      const rows = [...new Set(visibleItems.map((el) => el.offsetTop))];

      if (rows.length === 2) {
        setVisibleCount(count);
        setShowMore(true);
        return;
      }
      count--;
    }
    // fallback
    setVisibleCount(skills.length);
    setShowMore(false);
  }, [skills]);

  const exp = data.yearsofExperience;

  const cleanJobDesc = data.jobDesc?.replace(/style="[^"]*"/g, "");

  return (
    <Card
      className={
        selectedCard === data.id ? "candidate-card active" : "candidate-card"
      }
    >
      <div
        style={{
          display: "flex",
          alignContent: "space-between",
          justifyContent: "space-between",
        }}
      >
        <Box
          className="candidate-header"
          onClick={(e) => onEventHandler("view")}
        >
          <Typography className="candidate-name">{data?.jobTitle}</Typography>
        </Box>
        <Box className="header-icons">
          <IconButton
            size="small"
            onClick={(e) => onEventHandler("newTab")}
            title="View applicant details"
          >
            <img
              src="/ats/assests/img/newtabIcon.svg"
              alt="new tab icon"
              style={{ width: "16px", marginLeft: "8px", marginBottom: "5px" }}
            />
          </IconButton>
          <IconButton
            size="small"
            style={{ display: selectedCard ? "none" : "inline-flex" }}
            onClick={() => {
              onCheckboxChange(data, !data.isChecked);
            }}
          >
            {data?.isChecked ? (
              <div>
                <CheckBoxIcon fontSize="small" sx={{ color: "var(--primary-bg-color)" }} />
              </div>
            ) : (
              <div className="newCardCheckbox">
                <CheckBoxOutlineBlankIcon fontSize="small" />
              </div>
            )}
          </IconButton>
        </Box>
      </div>
      <CardContent
        className="candidate-content"
        onClick={(e) => onEventHandler("view")}
      >
        <div className={`candidate-container1 ${"no-fields"}`}>
          {data.jobCode && (
            <Typography className="candidate-id b-500">
              {data.jobCode}
            </Typography>
          )}

          {/* ROLE – always rendered */}
          <Typography className="candidate-role role-slot b-500">
            {data?.clientName || "-"}
          </Typography>
          <Box className="meta-info">
            <img
              src="/ats/assests/img/locationIconNewApplicantCard.svg"
              alt=""
            />
            <Typography className="candidate-role">
              <span className="b-500">Location: </span>
              {data.location?.trim() || " - "}
            </Typography>
          </Box>
          <Box className="meta-info">
            <img src="/ats/assests/img/common_currency.svg" alt="" />
            <Typography className="candidate-role">
              <span className="b-500">Pay Rate: </span>
              {data.payBillRate?.trim() || " - "}
            </Typography>
          </Box>
        </div>

        <Box className="detail-row">
          <Typography className="value">
            {data.jobDesc ? (
              <span
                className="JDline-clamp"
                dangerouslySetInnerHTML={{ __html: cleanJobDesc }}
              />
            ) : (
              <span> -</span>
            )}
          </Typography>
        </Box>

        <div className="skills-section1">
          <p className="skills-title b-500">Skills</p>
          <div className="skills-wrapper">
            {/* hidden measurement container */}
            <div className="skills-container measure" ref={skillcontainer}>
              {skills?.map((skill, i) => (
                <span className="chip" key={i}>
                  {skill}
                </span>
              ))}
            </div>
            {/* visible container */}
            <div className="skills-container">
              {skills?.length > 0 ? (
                <>
                  {skills.slice(0, visibleCount).map((skill, i) => (
                    <span className="chip" key={i}>
                      {skill}
                    </span>
                  ))}
                  {skills.length > visibleCount && (
                    <span
                      className="more-text"
                      style={{
                        fontSize: "12px",
                        lineHeight: "2",
                        fontStyle: "italic",
                        color: "#000000",
                      }}
                    >
                      &nbsp;& {skills.length - visibleCount} More
                    </span>
                  )}
                </>
              ) : (
                "-"
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NewJobpostingCard;
